import { provideSoftAppsModule, withSoftAppsModuleRoutes } from '@softapps/core';
import { mdeInventoryRoutes } from './inventory.routes';
import { SOFTLINE_PERMISSION_MDE_INVENTORY } from './inventory.permissions';
import { inject, provideEnvironmentInitializer } from '@angular/core';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';

export function provideMdeInventoryModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'Inventur',
        title: 'Inventur',
        icon: 'fa-regular fa-shelves',
        route: '/mde-inventur',
        permission: SOFTLINE_PERMISSION_MDE_INVENTORY,
      },
      withSoftAppsModuleRoutes({ app: mdeInventoryRoutes })
    ),
    provideEnvironmentInitializer(async () => {
      const store = inject(Store);
      store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
        module: 'mdeInventur',
        language: 'de',
        translations: de,
      });
    }),
  ];
}
